document.addEventListener("DOMContentLoaded", () => {

    window.dataLayer = window.dataLayer || [];

    document.querySelectorAll("[data-gtm=form]").forEach(form => {

        form.addEventListener("form.stepCompleted", (e) => {

            let amount = Number(e.target.querySelector("[name='FormModel.Gift.Amount.Amount']:checked")?.value);

            if (!amount) {
                amount = e.target.querySelector("[name='FormModel.Gift.Amount.CustomAmount']")?.value;
            }

            if (!amount) {
                amount = e.target.dataset.gtmAmount;
            }

            if (!amount) {
                amount = "";
            }

            let product = e.target.dataset.gtmProduct;

            const data = {
                event: "donation",
                product: product,
                amount: String(amount),
                step: e.target.dataset.gtmStep
            }

            console.log(data);

            dataLayer.push(data);
        });
    });

}, false);